import { type ReactNode } from 'react'
import { AccessDeniedPage, LoadingSpinner } from '@m3-tech/boss-ui'
import { useEmployee } from '@/hooks/useEmployee'
import { canAccessBrokerPlatformPrivacyPolicy } from '@/pages/BrokerPlatformPrivacyPolicies/access'

interface PrivacyPolicyGuardedRouteProps {
    children: ReactNode
}

export function PrivacyPolicyGuardedRoute({ children }: PrivacyPolicyGuardedRouteProps) {
    const { data: employeeData, isLoading } = useEmployee()

    if (isLoading) return <LoadingSpinner />

    if (!canAccessBrokerPlatformPrivacyPolicy(employeeData)) return <AccessDeniedPage />

    return <>{children}</>
}
